import { useMemo } from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

import { IconChevronLeft, IconClose, ItemStepper, StepProps, Text } from '@fhs/ui';

import { useIsItemInCart, useOfferCart } from '../../state/offer-guide-cart-state';

interface NavigationProps {
  onPressPrev: () => void;
  onPressStep: (index: number) => void;
  onClose: () => void;
}

export function Navigation({ onPressPrev, onPressStep, onClose }: NavigationProps) {
  const { steps: offerSteps, currentStepIndex, showSummary } = useOfferCart();
  const isItemInCart = useIsItemInCart();

  const steps = useMemo(
    () =>
      offerSteps.map<StepProps>((offerStep, index) => ({
        image: offerStep?.selectedEntry?.image?.asset?.url,
        isActive: currentStepIndex === index,
      })),
    [offerSteps, currentStepIndex]
  );
  const hasOneStep = steps.length === 1;

  return (
    <View style={styles.navigation}>
      <TouchableOpacity style={{ justifyContent: 'center' }} onPress={onPressPrev}>
        <IconChevronLeft size={24} />
      </TouchableOpacity>
      <View style={styles.itemStepperContainer}>
        {!isItemInCart && !hasOneStep && <ItemStepper steps={steps} onStepClick={onPressStep} />}
        {hasOneStep && !showSummary && !isItemInCart && (
          <Text.Ui size="md" weight="semibold">
            Item Selection
          </Text.Ui>
        )}
      </View>
      <TouchableOpacity style={{ justifyContent: 'center' }} onPress={onClose}>
        <IconClose size={24} />
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  itemStepperContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
    height: 42,
  },
  navigation: {
    flexDirection: 'row',
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
});
